<div class="date-input-container" [ngClass]="{ 'has-errors': hasErrors }">
  <boi-validation-error-generic
    (errorChange)="onErrorChange($event)"
    [validationErrors]="validationErrors"
    [propertyNames]="validationPropertyNames"
  >
  </boi-validation-error-generic>
  <kendo-textbox-container>
    <div [ngClass]="cssClasses" class="field-container">
      <div class="field-label" [boiRequiredFormField]="required ? labelName : undefined">
        <div class="label-content">
          <label [innerHtml]="labelName | localizeLabel" [for]="controlId ? controlId : labelName"> </label>
        </div>
        <boi-tooltip *ngIf="showTooltip" [tooltipName]="tooltipName ? tooltipName : labelName"> </boi-tooltip>
      </div>

      <div class="date-input">
        <boi-date-input [isDisabled]="isFieldDisabled" [(date)]="value" (dateChange)="valueChange.emit(value)">
        </boi-date-input>
      </div>
    </div>
  </kendo-textbox-container>
</div>
